import { CustomerFormResponse } from '@b2b/common/services/api/ordersApi/types';
import { ApiService } from '@b2b/common/services/api/types';
import { extractACMEPayload, TODO } from '@b2b/types/core';
import angular, { IQService } from 'angular';
import { MembershipDetailsVM } from '../../../../membership/detail/controllers/types';

export class CustomersIndividualsDetailService {
  static $inject = ['$q', 'ApiService', 'OrderService'];

  constructor(private $q: IQService, private apiService: ApiService, private orderService: TODO) {}

  getMembershipData(formsList: CustomerFormResponse[]) {
    const membershipsPromises = formsList
      .filter((item) => item.formCategoryType === 'membership')
      .map((item) => this.apiService.membership.detail(item.membershipId));

    return Promise.all(membershipsPromises).then((responses) => {
      return responses.map(extractACMEPayload()).filter((item) => !!item);
    });
  }

  getFormMetaData(formsList: CustomerFormResponse[]) {
    // TODO: APP-4349 - Why is this returning `MembershipDetailsVM[]` instead of `MembershipDetails[]`?
    return this.getMembershipData(formsList).then((memberships: MembershipDetailsVM[]) => {
      const membershipsData: Record<number, { membershipLevel: string; membershipOffering: string }> = {};

      for (const membership of memberships) {
        const membershipLevel = membership.membershipCategory;
        const membershipOffering = membership.offeringName;

        membershipsData[membership.id] = {
          membershipLevel,
          membershipOffering,
        };
      }

      return membershipsData;
    });
  }

  getMembershipLifecycle(itemType: TODO) {
    return this.orderService.getItemType(itemType, true);
  }
}

export const CustomersIndividualsDetailServiceModule = angular
  .module('acme.view.application.customers.individuals.detail.service', [
    'acme.common.service.api',
    'acme.common.service.order',
  ])
  .service('CustomersIndividualsDetailService', CustomersIndividualsDetailService).name;
